import * as ActionTypes from "services/state/action-types";

const SYSTEM_INITIAL_STATE = { unavailable: false };

export function system(state = SYSTEM_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_PRODUCT_DETAIL_FAIL:
    case ActionTypes.UPDATE_CUSTOMER_FAIL:
    case ActionTypes.CREATE_CONTACT_FAIL:
    case ActionTypes.UPDATE_CONTACT_FAIL:
    case ActionTypes.REMOVE_CONTACT_FAIL:
    case ActionTypes.SEND_USER_ACTIVATION_EMAIL_FAIL:
    case ActionTypes.CREATE_INCIDENT_ORDER_FAIL:
    case ActionTypes.SET_ACCOUNT_ALIAS_NAME_FAIL:
      return { ...state, loading: false, unavailable: true };

    case ActionTypes.LOGIN_FAIL:
      return {
        ...state,
        unavailable:
          !action.error.response || action.error.response.status !== 401,
      };

    case ActionTypes.CLOSE_MODAL:
      return { ...state, unavailable: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/system/reducer.js